import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Base from './Base';
import TextField from 'components/TextInput';
import Literal from 'components/Literal'; // FIXME Please use getLiteral here

const propTypes = {
    label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    hint: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    onChange: PropTypes.func,
    onRemove: PropTypes.func,
    value: PropTypes.any,
    className: PropTypes.string,
    error: PropTypes.any,
    mandatory: PropTypes.bool,
    readOnly: PropTypes.bool,
    hidden: PropTypes.bool,

    filter: PropTypes.func,
    format: PropTypes.func,
    min: PropTypes.number,
    max: PropTypes.number,
    description: PropTypes.string,
    labelMode: PropTypes.string,
};

class Formatted extends PureComponent {
    static defaultProps = {
        value: {},
        mandatory: false,
        readOnly: false,
        hidden: false,
    };

    constructor(props) {
        super(props);
        this.changed = !!(props?.value?.from && props?.value?.to);
        this.state = {
            values: { from: props?.value?.from, to: props?.value?.to },
        };
    }

    componentDidUpdate(prevProps) {
        const { value, bothValues } = this.props;
        const stateValues = this.state.values;
        if (
            bothValues &&
            prevProps &&
            !value.from &&
            !value.to &&
            stateValues.to &&
            stateValues.from
        ) {
            this.setState({
                values: {
                    from: value.from,
                    to: value.to,
                },
            });
        }
    }

    min = (value) => {
        let { min } = this.props;
        return min && value < min ? min : value;
    };

    max = (value) => {
        let { max } = this.props;
        return max && value > max ? max : value;
    };

    onChange = (range) => {
        return (newValue) => {
            let { onChange, value = {}, bothValues } = this.props;
            const { values } = this.state;

            const from = bothValues ? values.from : value.from;
            const to = bothValues ? values.to : value.to;

            let newValues = {
                from: this.min(from),
                to: this.max(to),
            };

            newValues[range] = newValue;

            if (bothValues) {
                if (
                    (newValues.from && newValues.to) ||
                    (!newValues.from && !newValues.to && this.changed)
                ) {
                    this.changed = !!(newValues.from && newValues.to);
                    onChange && onChange(newValues, null, true);
                }

                this.setState({ values: newValues });
                // only if we have both values
            } else onChange && onChange(newValues, null, true);
        };
    };

    render() {
        let {
            label,
            description,
            hidden,
            mandatory,
            value = {},
            labelMode,
            type,
            isBulkAction,
            bothValues = false,
        } = this.props;
        const { values } = this.state;

        if (hidden) return null;

        const from = bothValues ? values.from : value.from;
        const to = bothValues ? values.to : value.to;

        return (
            <Base
                className="fm-field-input fm-field-range"
                label={label}
                mandatory={mandatory}
                description={description}
                labelMode={labelMode}
                isBulkAction={isBulkAction}
                onReset={this.props.onChange}
            >
                <TextField
                    hintText={<Literal literal="placeholder_since" />}
                    onChange={this.onChange('from')}
                    type={type}
                    value={this.min(from) || null}
                    blurOnEnter={true}
                />
                <span className="fm-range-field-sep"> - </span>
                <TextField
                    hintText={<Literal literal="label_until" />}
                    onChange={this.onChange('to')}
                    type={type}
                    value={this.max(to) || null}
                    blurOnEnter={true}
                />
            </Base>
        );
    }
}

Formatted.propTypes = propTypes;

export default Formatted;
